export default __webpack_public_path__ + "static/media/hht2_ep09_timeline_q04_b.1b634e0d.png";